import React from 'react';

interface IUserProfileDetailProps {
    children?: React.ReactNode;
}

export const UserProfileDetail: React.FC<IUserProfileDetailProps> = ({ children }) => {
    return (
        <div className="user-profile-detail" style={{ width: '100%', fontSize: '1.2rem', display: 'flex', flexDirection: 'column', gap: '.6rem' }}>
            {children}
        </div>
    );
};
